// extracted by mini-css-extract-plugin
var _1 = "Control_actions__07eba";
var _2 = "Control_addBottom__5c2e5";
var _3 = "Control_addLeft__9ba11";
var _4 = "Control_addRight__97680";
var _5 = "Control_addTop__04cac";
var _6 = "Control_border__12d0b";
var _7 = "Control_comments__287da";
export { _1 as "actions", _2 as "addBottom", _3 as "addLeft", _4 as "addRight", _5 as "addTop", _6 as "border", _7 as "comments" }
